import { UsersIcon } from "icons/outline";

export const EmptyAssignedAccounts = () => (
  <div className="flex items-center justify-center space-x-1 text-sm text-foundations-subtle">
    <UsersIcon className="h-4 w-4" />
    <span>No assigned accounts yet.</span>
  </div>
);
